import Link from "next/link";
import { lazy, Suspense } from "react";
import { AccountValidation, NavLinks, UserMenus } from "./types";

// Lazy: account validation (incl. libphonenumber-js ~224 KiB source + search-autocomplete + fuse.js)
// is only shown to authenticated users with a pending validation.
const UserAccountValidation = lazy(() => import("./accountValidation"));

type LeftMenusProps = {
  topNavLinks: NavLinks[];
  accountValidationContent: AccountValidation;
  onNavMenuHover: (navMenuTitle: string) => void;
  userData: UserMenus;
  isBotBPassHeader?: boolean;
};

const LeftMenus = ({
  topNavLinks,
  accountValidationContent,
  onNavMenuHover,
  userData,
  isBotBPassHeader,
}: LeftMenusProps) => {
  return isBotBPassHeader ? (
    <div className="flex justify-start items-center w-[40%]">
      <svg
        className="cursor-pointer"
        onClick={() => history.go(-1)}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none">
        <path
          d="M6.66602 16H25.3327M6.66602 16L14.666 24M6.66602 16L14.666 8"
          stroke="#4C4C52"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  ) : (
    <div className="flex justify-start items-center gap-4 w-[40%]">
      {topNavLinks?.map(link => (
        <div
          key={link.Title}
          className={`text-[#696971] text-center w-40 font-medium h-full cursor-pointer content-center uppercase hover:text-[#FF8200] hover:border-b-2 hover:border-solid hover:border-[#ff8200] transition-all delay-[.2s] ease-in-out`}
          onMouseEnter={() => onNavMenuHover(link.Title)}>
          <Link href={link.Url}>{link.Title}</Link>
        </div>
      ))}
      {userData?.IsAuthenticated && userData?.ShouldShowAccountValidation && (
        <Suspense fallback={null}>
          <UserAccountValidation accountValidationContent={accountValidationContent} />
        </Suspense>
      )}
    </div>
  );
};

export default LeftMenus;
